module.exports = "<div class=\"modal-header modal-header-dark\">\n    <h1 class=\"modal-header-text\">{{title}}</h1>\n</div>\n<div class=\"modal-body\" style=\"padding:20px;\">\n    <span style=\"font-size: 16px\">{{message}}</span>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-success\" ng-click=\"ok()\" style=\"text-transform:capitalize;\" translate>OK</button>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/templates/common/modalPopup.html
// module id = 3
// module chunks = 0